import { StyleSheet, View } from 'react-native';
import { Text } from '@/components/common/AppText';
import { TEXT_START, useJourneyPalette } from './journey-theme';

/**
 * Label + large date (`.date-hero`), e.g. "Pro benefits stay until" / "12 Oct
 * 2026". Callers pass an already-formatted date or the "check when your access
 * ends" wording - never a guessed date.
 */
export function DateHero({ label, value }: { label: string; value: string }) {
  const palette = useJourneyPalette();
  return (
    <View
      style={[styles.hero, { borderBottomColor: palette.line }]}
      accessible
      accessibilityLabel={`${label} ${value}`}
    >
      <Text style={[styles.label, { color: palette.secondary }, TEXT_START]}>{label}</Text>
      <Text style={[styles.value, { color: palette.text }, TEXT_START]}>{value}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  hero: {
    marginTop: 23,
    paddingBottom: 19,
    marginBottom: 19,
    borderBottomWidth: StyleSheet.hairlineWidth,
  },
  label: { fontSize: 13, lineHeight: 19 },
  value: { fontSize: 25, fontWeight: '700', letterSpacing: -0.6, marginTop: 4 },
});
